<template>
  <div>
    <v-card class="pa-4">
      <v-card-title class="text-h6 font-weight-bold">
        Solicitudes de Certificados
      </v-card-title>

      <!-- Filtros -->
      <v-card class="mb-4 elevation-2">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          Filtros de Búsqueda
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-select v-model="estadoSolicitud" :items="estadosSolicitud" item-text="text" item-value="value"
                label="Estado de Solicitud" dense clearable return-object></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-select v-model="universidad" :items="universidades" item-text="nombre" item-value="id"
                label="Universidad" dense clearable return-object></v-select>
            </v-col>
          </v-row>

          <v-row justify="end" class="mt-2">
            <v-btn color="primary" @click="busqueda" elevation="1">
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card elevation="2">
        <v-card-text>
          <v-data-table :headers="headers" :items="solicitudes" :loading="loading" :search="search"
            loading-text="Cargando solicitudes..." class="elevation-1" dense>
            <template v-slot:top>
              <v-text-field v-model="search" label="Busqueda en la tabla" class="mx-4"></v-text-field>
            </template>
            <template v-slot:item.nombre_completo="{ item }">
              <div>
                <div class="font-weight-medium">
                  {{ item.Inscripcion.estudiante.nombres }}
                  {{ item.Inscripcion.estudiante.pri_apellido }}
                  {{ item.Inscripcion.estudiante.seg_apellido }}
                </div>
                <div class="text--secondary text-caption">
                  {{ item.Inscripcion.estudiante.num_doc }}
                </div>
              </div>
            </template>
            <!-- Acciones -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" @click="verSolicitud(item)" color="primary" v-bind="attrs" v-on="on">
                    mdi-eye
                  </v-icon>
                </template>
                <span>Ver Solicitud</span>
              </v-tooltip>
              <!-- <template v-if="item.Estado === 'listo_para_emitir'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success" small class="mr-2" @click="verCertificado(item)" v-bind="attrs" v-on="on">
                      mdi-eye
                    </v-icon>
                  </template>
                  <span>Ver Certificado</span>
                </v-tooltip>
              </template> -->




            </template>

            <!-- EsGratuito -->
            <template v-slot:item.EsGratuito="{ item }">
              <v-chip :color="item.EsGratuito ? 'green' : 'red'" dark small>
                {{ item.EsGratuito ? 'Gratuito' : 'No Gratuito' }}
              </v-chip>
            </template>

            <!-- Estado -->
            <template v-slot:item.Estado="{ item }">
              <v-chip :color="estadoColores[item.Estado]" dark small>
                {{ mostrarEstado(item.Estado) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Acciones Generales -->
      <!-- <v-card-actions class="justify-end mt-4">
    <v-btn color="error" :loading="cargando" @click="cerrarSolicitud">
      Cerrar
    </v-btn>
  </v-card-actions> -->
    </v-card>
    <v-dialog v-model="dialog1" max-width="600px" persistent>
      <v-card v-if="inscripcion">
        <v-card-title class="text-h6 font-weight-bold">
          Solicitud de Inscripción
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-list dense>

            <!-- Estudiante -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="indigo">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ inscripcion.Inscripcion.estudiante.nombres }}
                  {{ inscripcion.Inscripcion.estudiante.pri_apellido }}
                  {{ inscripcion.Inscripcion.estudiante.seg_apellido }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Documento: {{ inscripcion.Inscripcion.estudiante.num_doc }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar color="grey" size="80" tile class="avatar-border-solid">
                <v-img :src="fotoBase64"></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-divider inset></v-divider>

            <!-- Programa -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="deep-purple">mdi-school</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  {{ inscripcion.Inscripcion.programa.nombre_compuesto }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- Universidad -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="blue">mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ inscripcion.ProgramaUniversidad.Universidad.Nombre }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- Moneda y Precio -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="green">mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ inscripcion.ProgramaUniversidad.precio }} {{ inscripcion.ProgramaUniversidad.moneda }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- Razón -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="orange">mdi-comment-question</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  {{ inscripcion.RazonConcesion }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- Estado -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="darck">mdi-format-list-bulleted
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <v-chip :color="estadoColores[inscripcion.Estado]" dark small>
                    {{ mostrarEstado(inscripcion.Estado) }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list>

          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px"></iframe>
          <v-row v-if="inscripcion.Estado == 'emitido'">
            <v-col>
              <v-switch v-model="certificadoImprimir" :label="`Ver certificado Imprimir`"></v-switch>
            </v-col>
          </v-row>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="inscripcion.Estado === 'emitido'" color="primary" :loading="cargando"
            @click="generarResolucion(inscripcion, true)">
            <v-icon>{{ inscripcion.Certificado?.ResolucionUUID ? 'mdi-eye' : 'mdi-file-plus' }}</v-icon>
            {{ inscripcion.Certificado?.ResolucionUUID ? 'Ver Resolucion' : 'Generar Resolucion' }}
          </v-btn>

          <v-btn v-if="inscripcion.Estado === 'emitido'" color="primary" :loading="cargando"
            @click="verCertificado(inscripcion)">
            <v-icon>mdi-eye-refresh</v-icon>
            Ver Certificado
          </v-btn>

          <v-btn v-if="inscripcion.Estado === 'pendiente_aprobacion'" color="success" :loading="cargando"
            @click="aprobarSolicitud(inscripcion)">
            <v-icon left>
              mdi-check-circle
            </v-icon>
            Aprobar
          </v-btn>
          <v-btn v-if="inscripcion.Estado === 'pendiente_aprobacion'" color="error" :loading="cargando"
            @click="dialogRechazar">
            <v-icon left>
              mdi-close-circle
            </v-icon>
            Rechazar
          </v-btn>
          <v-btn v-if="inscripcion.Estado === 'listo_para_emitir'" color="primary" :loading="cargando"
            @click="generarCertificado(inscripcion, false)">
            <v-icon left>
              mdi-printer
            </v-icon>
            Emitir Certificado
          </v-btn>
          <v-btn v-if="inscripcion.Estado === 'listo_para_emitir'" color="secondary" :loading="cargando"
            @click="generarCertificado(inscripcion, true, true)">
            <v-icon left>
              mdi-printer-eye
            </v-icon>
            Previsualizar
          </v-btn>
          <v-btn color="danger" :loading="cargando" @click="cerrarDialog">
            <v-icon left>
              mdi-close
            </v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="dialog2" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6 font-weight-bold">Certificado</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog2 = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px"></iframe>
          <v-btn v-else color="primary" @click="generarCertificado">
            Generar Certificado
          </v-btn>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card v-if="inscripcion">
        <v-card-title class="text-h6 font-weight-bold">
          Rechazar Solicitud
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="motivo" label="Motivo" auto-grow></v-textarea>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn v-if="inscripcion.Estado === 'pendiente_aprobacion'" color="error" :loading="cargando"
            @click="rechazarSolicitud(inscripcion, motivo)">
            <v-icon left>
              mdi-close-circle
            </v-icon>
            Rechazar
          </v-btn>


          <v-btn color="danger" :loading="cargando" @click="cerrarSolicitud">
            <v-icon left>
              mdi-close
            </v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';


const API_URL = `${process.env.VUE_APP_API_CERTIFICACIONES}/api/v1`;

export default {
  name: 'SolicitudCertificado',
  data() {
    return {
      search: '',
      pdfUrl: null,
      certificadoImprimir: false,
      fotoBase64: "",
      loading: true,
      programas: [],
      solicitudes: [],
      programauniversidades: [],
      dialog1: false,
      dialog2: false,
      dialog: false,
      headers: [
        { text: 'ID', value: 'ID', sortable: true },
        // { text: 'Fecha Solicitud', value: 'fecha_solicitud', sortable: true },
        { text: 'Nombre Completo', value: 'nombre_completo', sortable: false },
        // { text: 'Estudiante', value: 'Inscripcion.estudiante.nombres', sortable: true },
        // { text: 'Apellido Paterno', value: 'Inscripcion.estudiante.pri_apellido', sortable: true },
        // { text: 'Apellido Materno', value: 'Inscripcion.estudiante.seg_apellido', sortable: true },
        { text: 'Num Documento', value: 'Inscripcion.estudiante.num_doc', sortable: true },

        //{ text: 'Fecha de Inscripción', value: 'Inscripcion.fecha_registro', sortable: true },
        { text: 'Universidad', value: 'ProgramaUniversidad.Universidad.Nombre', sortable: true },
        { text: 'Programa', value: 'ProgramaUniversidad.Programa.nombre_compuesto', sortable: true },
        { text: 'Sede', value: 'Inscripcion.programa.sede.nombre', sortable: true },
        { text: 'Precio', value: 'ProgramaUniversidad.precio' },
        { text: 'Moneda', value: 'ProgramaUniversidad.moneda' },
        { text: 'Fecha Sol', value: 'FechaSolicitudFormateada' },
        { text: 'Fecha Aprob', value: 'FechaAprobadoFormateada' },
        { text: 'Fecha Emitido', value: 'FechaEmitidoFormateada' },
        { text: 'Es Gratuito', value: 'EsGratuito' },
        { text: 'Estado', value: 'Estado' },

        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      estadosSolicitud: [
        { text: 'Pendiente de Pago', value: 'pendiente_pago' },
        { text: 'Pendiente de Aprobación', value: 'pendiente_aprobacion' },
        { text: 'Listo Para Emitir', value: 'listo_para_emitir' },
        { text: 'Emitido', value: 'emitido' },
        { text: 'Rechazado', value: 'rechazado' },
      ],
      estadoColores: {
        pendiente_pago: 'orange',
        pendiente_aprobacion: 'yellow darken-2',
        listo_para_emitir: 'blue',
        emitido: 'green',
        rechazado: 'red'
      },
      estadoSolicitud: { text: 'Pendiente de Aprobación', value: 'pendiente_aprobacion' },
      programauniversidad: null,
      universidad: null,
      universidades: [],


      opcionSeleccionada: null,
      motivo: '',
      inscripcion: null,
      padre: {},
      usuario: null,


      cargando: false,
      opciones: [
        { label: 'Pago realizado', value: 'paid' },
        { label: 'Otorgado por gestión', value: 'granted' }
      ]
    };
  },
  computed: {
    requiereMotivo() {
      return this.opcionSeleccionada === 'granted';
    }
  },
  mounted() {
    this.getConveniosUniversidades();
    this.busqueda();
  },

  methods: {
    async generarCertificado(inscripcion, imprimir = false, preview = false) {
      this.usuario = this.$store.state.DATA_USER;

      const config = {
        solicitud_id: inscripcion.ID,
        imprimir: imprimir,
        preview: preview,
        hr_id: this.usuario.id,
        // otros campos
      };

      try {
        const response = await xaxios.post(`${API_URL}/certificados/requests/generate`, config, {
          responseType: 'blob'
        }

        );

        const blob = response.data;
        this.pdfUrl = URL.createObjectURL(blob);
        if (imprimir) {
          // Si es para imprimir, abrir en una nueva ventana
          // const newWindow = window.open();
          // newWindow.document.write('<iframe src="' + this.pdfUrl + '" width="100%" height="100%"></iframe>');
        }

        // const response = await fetch("http://localhost:8008/api/v1/certificados/requests/generate", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify(config),
        // });
        // const blob = await response.blob();
        // this.pdfUrl = URL.createObjectURL(blob);
        if (!preview) {
          this.inscripcion.Estado = 'emitido';
          this.busqueda();


        }


        this.$root.$notify.show(`Generado Corrrectamente`, { color: 'success' });


      } catch (err) {
        window.console.error("Error generando certificado:", err);

        let errorMessage = 'Hubo un error inesperado al generar el certificado.';

        if (err.response) {
          // El servidor respondió con un status code fuera del rango 2xx
          // Aquí es donde comprobamos si la respuesta de error es un JSON.
          // xaxios intenta parsear automáticamente las respuestas JSON cuando responseType no es 'blob'
          // o cuando el Content-Type de la respuesta de error es 'application/json'.
          // Si el Content-Type es JSON, err.response.data ya será un objeto.
          // Si err.response.data sigue siendo un Blob (porque el backend devolvió un blob con status de error),
          // tendremos que leerlo explícitamente.

          if (err.response.data instanceof Blob) {
            // Si el Content-Type del error NO era application/json, xaxios aún lo dejó como Blob.
            // Necesitamos leerlo para ver si es un JSON adentro.
            const reader = new FileReader();
            reader.onload = async () => {
              try {
                const errorJson = JSON.parse(reader.result);
                errorMessage = `Error del servidor (${err.response.status}): ${errorJson.message || errorJson.error || JSON.stringify(errorJson)}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              } catch (e) {
                // No es un JSON válido o hubo otro problema al leer el blob de error
                errorMessage = `Error del servidor (${err.response.status}): ${err.response.statusText || 'Respuesta de error no legible.'}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              }
            };
            reader.readAsText(err.response.data);
            // Retornamos aquí porque la notificación se mostrará asincrónicamente
            return;
          } else if (typeof err.response.data === 'object' && err.response.data !== null) {
            // Si err.response.data ya es un objeto (porque Content-Type era application/json)
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data.message || err.response.data.error || JSON.stringify(err.response.data)}`;
          } else {
            // Si no es un Blob ni un objeto, podría ser texto plano o vacío
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data || err.response.statusText || 'Respuesta de error desconocida.'}`;
          }

        } else if (err.request) {
          // La petición fue hecha pero no se recibió respuesta (ej: red, CORS)
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión de red o la configuración CORS.';
        } else {
          // Algo sucedió al configurar la petición
          errorMessage = `Error de la aplicación: ${err.message}`;
        }

        // Muestra el snackbar con el mensaje de error (si no fue manejado asincrónicamente por el FileReader)
        if (!(err.response && err.response.data instanceof Blob)) {
          this.showSnackbar(errorMessage, 'error');
        }
        window.console.error("Error generando certificado:", err.response.data.error);

        this.$root.$notify.show(errorMessage, { color: 'error' });


        //window.console.error("Error generando certificado:", err);

      }
    },
    async generarResolucion(inscripcion, imprimir = false, preview = false) {
      this.usuario = this.$store.state.DATA_USER;
      this.cargando = true;

      const config = {
        solicitud_id: inscripcion.ID,
        imprimir: imprimir,
        preview: preview,
        hr_id: this.usuario.id,
        // otros campos
      };

      try {
        const response = await xaxios.post(`${API_URL}/certificados/requests/resolucion`, config, {
          responseType: 'blob'
        }

        );

        const blob = response.data;
        this.pdfUrl = URL.createObjectURL(blob);
                
        if (!preview) {        
          this.busqueda();
        }


        this.$root.$notify.show(`Generado Corrrectamente`, { color: 'success' });


      } catch (err) {
        window.console.error("Error generando certificado:", err);

        let errorMessage = 'Hubo un error inesperado al generar la resolucion.';

        if (err.response) {
          // El servidor respondió con un status code fuera del rango 2xx
          // Aquí es donde comprobamos si la respuesta de error es un JSON.
          // xaxios intenta parsear automáticamente las respuestas JSON cuando responseType no es 'blob'
          // o cuando el Content-Type de la respuesta de error es 'application/json'.
          // Si el Content-Type es JSON, err.response.data ya será un objeto.
          // Si err.response.data sigue siendo un Blob (porque el backend devolvió un blob con status de error),
          // tendremos que leerlo explícitamente.

          if (err.response.data instanceof Blob) {
            // Si el Content-Type del error NO era application/json, xaxios aún lo dejó como Blob.
            // Necesitamos leerlo para ver si es un JSON adentro.
            const reader = new FileReader();
            reader.onload = async () => {
              try {
                const errorJson = JSON.parse(reader.result);
                errorMessage = `Error del servidor (${err.response.status}): ${errorJson.message || errorJson.error || JSON.stringify(errorJson)}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });
                //                this.showSnackbar(errorMessage, 'error');
              } catch (e) {
                // No es un JSON válido o hubo otro problema al leer el blob de error
                errorMessage = `Error del servidor (${err.response.status}): ${err.response.statusText || 'Respuesta de error no legible.'}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });
                //                this.showSnackbar(errorMessage, 'error');
              }
            };
            reader.readAsText(err.response.data);
            // Retornamos aquí porque la notificación se mostrará asincrónicamente
            return;
          } else if (typeof err.response.data === 'object' && err.response.data !== null) {
            // Si err.response.data ya es un objeto (porque Content-Type era application/json)
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data.message || err.response.data.error || JSON.stringify(err.response.data)}`;
          } else {
            // Si no es un Blob ni un objeto, podría ser texto plano o vacío
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data || err.response.statusText || 'Respuesta de error desconocida.'}`;
          }

        } else if (err.request) {
          // La petición fue hecha pero no se recibió respuesta (ej: red, CORS)
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión de red o la configuración CORS.';
        } else {
          // Algo sucedió al configurar la petición
          errorMessage = `Error de la aplicación: ${err.message}`;
        }

        // Muestra el snackbar con el mensaje de error (si no fue manejado asincrónicamente por el FileReader)
        if (!(err.response && err.response.data instanceof Blob)) {
          this.showSnackbar(errorMessage, 'error');
        }
        window.console.error("Error generando certificado:", err.response.data.error);        
        this.$root.$notify.show(errorMessage, { color: 'error' });
      }finally {
        this.cargando = false;
      }
    },
    async getConveniosUniversidades() {
      let vue = this;
      vue.loading = true;
      const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        let conves = data.getInstituciones;
        conves = conves.filter(x => { return x.convenio });
        this.universidades = conves;
        vue.loading = false;
      });
    },
    async openDialog() {
      this.dialog1 = true
      try {
        if (this.inscripcion) {
          const response = await xaxios.get(`${API_URL}/programas/${this.inscripcion.idprograma}/universidad/certificado`);
          this.programauniversidades = response.data || [];
          window.console.log(this.programauniversidades)

        }

      } catch (error) {
        window.console.error("Error al obtener los programas:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }
    },
    cerrarDialog() {
      this.dialog1 = false
    },

    cerrarSolicitud() {
      this.dialog = false;
      this.$emit('cerrar');
    },

    async showThisView(persona_id, inscripcion_id, padre) {
      this.usuario = this.$store.state.DATA_USER;

      this.padre = padre;
      this.loading = true;

      try {
        const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        this.solicitudes = response.data || [];
        window.console.log(this.solicitudes)
      } catch (error) {
        window.console.error("Error al obtener los programas:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }

      this.inscripcion = await this.get_data_inscripcion(inscripcion_id);
      if (!this.inscripcion.plan_pagos) this.inscripcion.plan_pagos = [];
      //window.console.log('......', this.inscripcion, inscripcion_id);
      this.inscripcion.plan_pagos.forEach((plan) => {
        if (plan.monto != plan.saldo) {
          this.existRecibo = true;
          return;
        }
      });
      this.dialog = true;
      // window.console.log('this.inscripcion', JSON.stringify(this.inscripcion));
      // window.console.log('plan_pagos', JSON.stringify(this.plan_pagos));
    },
    async get_data_inscripcion(id) {
      if (this.padre) this.padre.loadinddeta = true;
      const sql = gql`query{ getInscripcion(id:${id}){
            id,idprograma,idestudiante,estado_ins,observaciones,idasesor,fecha_registro,registrado_por,tipopago,puede_cambiar
            asesor {id nombres pri_apellido seg_apellido}
            estudiante {id num_doc nombres pri_apellido seg_apellido domicilio telefono1 telefono2 email fecha_nac contacto estado}
            programa {nombre_compuesto,universidad{id nombre} sede{id nombre}}
            plan_programa {id nombre aprobado, cobros_programa{ id monto cuotas estado concepto_pago{id,nombre} }}
            plan_pagos { id monto saldo nro_cuota descuento fecha_pago bloqueado saldo_regularizado concepto_pago{id,nombre}}
            more_programas{ id, nombre_compuesto sede{ id nombre} gestion}
            # pagos_inscripcion {}
        }}`;
      return this.$apollo
        .query({ query: sql })
        .then(({ data }) => {
          //window.console.log(this.programa.id, 'dfsfs');

          if (this.padre) this.padre.loadinddeta = false;
          return data.getInscripcion;
        })
        .catch((e) => {
          window.console.log('------------', e);
          if (this.padre) this.padre.loadinddeta = false;
          this.$root.$notify.show(`No de puede cargar el detalle`, { color: 'info' });
          return {};
        });
    },
    dialogRechazar() {
      this.dialog = true;
      this.motivo = '';
      this.opcionSeleccionada = null;
    },
    async rechazarSolicitud(inscripcion, motivo) {
      window.console.log("rechazando solicitud con motivo: ", motivo)

      this.usuario = this.$store.state.DATA_USER;
      if (!inscripcion) {
        this.$emit('error', 'Debes seleccionar una inscripción');
        return;
      }
      this.usuario = this.$store.state.DATA_USER;
      if (!this.usuario) {
        this.$emit('error', 'Usuario no encontrado');
        return;
      }
      if (!this.usuario.id) {
        this.$emit('error', 'Usuario no tiene ID');
        return;
      }
      if (!inscripcion.ID) {
        this.$emit('error', 'Inscripción no tiene ID');
        return;
      }
      this.cargando = true;
      try {
        const payload = {
          // hr_id: this.inscripcion.id,
          // option_id: this.programauniversidad.id,
          // opcion: this.opcionSeleccionada,
          // reason: this.motivo,
          hr_id: this.usuario.id,
          reason: motivo
        };

        const response = await xaxios.post(`${API_URL}/certificados/request/${inscripcion.ID}/reject`, payload)

        // Puedes capturar y verificar el status
        if (response.status === 200 || response.status === 201) {
          this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });
          this.busqueda(); // Recargar solicitudes después de enviar
          //this.busqueda(); // Recargar solicitudes después de enviar
        } else {
          this.$root.$notify.show(`Solicitud enviada, pero con advertencia (status ${response.status})`, { color: 'warning' });
        }
        // Suponiendo que tienes un servicio API:
        //  const response = xaxios.post(`${API_URL}/certificados/request/${inscripcion.ID}/approve`, payload)
        //const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        //this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });

      } catch (err) {

        this.$root.$notify.show(`Error al realizar la solicitud`, { color: 'error' });
      } finally {
        this.cargando = false;
      }
    },
    async aprobarSolicitud(inscripcion) {
      this.usuario = this.$store.state.DATA_USER;
      if (!inscripcion) {
        this.$emit('error', 'Debes seleccionar una inscripción');
        return;
      }
      this.usuario = this.$store.state.DATA_USER;
      if (!this.usuario) {
        this.$emit('error', 'Usuario no encontrado');
        return;
      }
      if (!this.usuario.id) {
        this.$emit('error', 'Usuario no tiene ID');
        return;
      }
      if (!inscripcion.ID) {
        this.$emit('error', 'Inscripción no tiene ID');
        return;
      }
      this.cargando = true;
      try {
        const payload = {
          // hr_id: this.inscripcion.id,
          // option_id: this.programauniversidad.id,
          // opcion: this.opcionSeleccionada,
          // reason: this.motivo,
          hr_id: this.usuario.id
        };

        const response = await xaxios.post(`${API_URL}/certificados/request/${inscripcion.ID}/approve`, payload)

        // Puedes capturar y verificar el status
        if (response.status === 200 || response.status === 201) {
          this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });
          this.busqueda(); // Recargar solicitudes después de enviar
          //this.busqueda(); // Recargar solicitudes después de enviar
        } else {
          this.$root.$notify.show(`Solicitud enviada, pero con advertencia (status ${response.status})`, { color: 'warning' });
        }
        // Suponiendo que tienes un servicio API:
        //  const response = xaxios.post(`${API_URL}/certificados/request/${inscripcion.ID}/approve`, payload)
        //const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        //this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });

      } catch (err) {

        this.$root.$notify.show(`Error al realizar la solicitud`, { color: 'error' });
      } finally {
        this.cargando = false;
      }
    },
    async busqueda() {
      this.loading = true;
      try {
        window.console.log("buscando solicitudes con estado: ", this.estadoSolicitud.value, " y universidad: ", this.universidad)
        const response = await xaxios.get(`${API_URL}/certificados/requests`, {
          params: {
            estado: this.estadoSolicitud.value,
            universidad: this.universidad
          }
        });

        window.console.log("asdfasdfasdfasd fas asdf ", response)
        this.solicitudes = response.data || [];
        //const pad = (n) => n.toString().padStart(2, '0');
        if (this.solicitudes.length > 0) {
          const solicitudesConInscripcion = await Promise.all(
            this.solicitudes.map(async solicitud => {


              const inscripcion = await this.get_data_inscripcion(solicitud.InscripcionID);
              return {
                ...solicitud,
                Inscripcion: inscripcion,
                FechaSolicitudFormateada: this.formatDate(solicitud.FechaCreacion),
                FechaAprobadoFormateada: this.formatDate(solicitud.FechaAprobado),
                FechaEmitidoFormateada: this.formatDate(solicitud.FechaEmitido),
              };
            })
          );
          this.solicitudes = solicitudesConInscripcion;
        }
        window.console.log(this.solicitudes);
      } catch (error) {
        window.console.error("Error al obtener las solicitudes:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }
    },
    pad(n) {
      return n.toString().padStart(2, "0");
    },

    formatDate(dateInput) {
      if (!dateInput) return "";
      const date = new Date(dateInput);
      if (isNaN(date.getTime())) return "";
      return `${this.pad(date.getDate())}/${this.pad(date.getMonth() + 1)}/${date.getFullYear()} ${this.pad(date.getHours())}:${this.pad(date.getMinutes())}`;
    },




    mostrarEstado(estado) {
      const mapa = {
        pendiente_pago: 'Pendiente de Pago',
        pendiente_aprobacion: 'Pendiente de Aprobación',
        listo_para_emitir: 'Listo Para Emitir',
        emitido: 'Emitido',
        rechazado: 'Rechazado'
      };
      return mapa[estado] || estado;
    },

    async verSolicitud(item) {
      this.pdfUrl = null; // Resetear URL del PDF
      this.fotoBase64 = "";

      try {
        if (item.FotoUUID) {
          const response = await xaxios.get(`${API_URL}/certificados/requests/foto/${item.FotoUUID}`);
          // this.solicitudes = response.data || [];
          const imageB64 = response.data.file64
          this.fotoBase64 = `data:${response.data.mimetype};base64,${imageB64}`
          this.$root.$notify.show(`Obtenido la Fotografia Corrrectamente`, { color: 'success' });

        } else {
          this.$root.$notify.show(`Aun no tiene fotografia para el certificado`, { color: 'warning' });

        }

      } catch (error) {
        this.$root.$notify.show(`Error al obtener la fotografia`, { color: 'error' });


        // alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }

      // const response = await xaxios.get(`${API_URL}/certificados/requests/foto/${item.FotoUUID}`);
      //  // this.solicitudes = response.data || [];
      //  const imageB64=response.data.file64
      //  this.fotoBase64=`data:${response.data.mimetype};base64,${imageB64}`
      this.inscripcion = item;
      window.console.log('verSolicitud', item);
      this.dialog1 = true;
    },

    async verCertificado(item) {
      window.console.log('verCertificado', item);
      this.cargando = true;

      try {
        const response = await xaxios.get(`${API_URL}/certificados/request/${item.ID}/certificado`, {
          params: {
            isimprimir: this.certificadoImprimir
          },
          responseType: 'blob'

        });


        const blob = response.data;
        this.pdfUrl = URL.createObjectURL(blob);
        //this.busqueda();

        this.$root.$notify.show(`Obtenido Corrrectamente`, { color: 'success' });


      } catch (err) {
        window.console.error("Error generando certificado:", err);

        let errorMessage = 'Hubo un error inesperado al generar el certificado.';

        if (err.response) {
          // El servidor respondió con un status code fuera del rango 2xx
          // Aquí es donde comprobamos si la respuesta de error es un JSON.
          // xaxios intenta parsear automáticamente las respuestas JSON cuando responseType no es 'blob'
          // o cuando el Content-Type de la respuesta de error es 'application/json'.
          // Si el Content-Type es JSON, err.response.data ya será un objeto.
          // Si err.response.data sigue siendo un Blob (porque el backend devolvió un blob con status de error),
          // tendremos que leerlo explícitamente.

          if (err.response.data instanceof Blob) {
            // Si el Content-Type del error NO era application/json, xaxios aún lo dejó como Blob.
            // Necesitamos leerlo para ver si es un JSON adentro.
            const reader = new FileReader();
            reader.onload = async () => {
              try {
                const errorJson = JSON.parse(reader.result);
                errorMessage = `Error del servidor (${err.response.status}): ${errorJson.message || errorJson.error || JSON.stringify(errorJson)}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              } catch (e) {
                // No es un JSON válido o hubo otro problema al leer el blob de error
                errorMessage = `Error del servidor (${err.response.status}): ${err.response.statusText || 'Respuesta de error no legible.'}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              }
            };
            reader.readAsText(err.response.data);
            // Retornamos aquí porque la notificación se mostrará asincrónicamente
            return;
          } else if (typeof err.response.data === 'object' && err.response.data !== null) {
            // Si err.response.data ya es un objeto (porque Content-Type era application/json)
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data.message || err.response.data.error || JSON.stringify(err.response.data)}`;
          } else {
            // Si no es un Blob ni un objeto, podría ser texto plano o vacío
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data || err.response.statusText || 'Respuesta de error desconocida.'}`;
          }

        } else if (err.request) {
          // La petición fue hecha pero no se recibió respuesta (ej: red, CORS)
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión de red o la configuración CORS.';
        } else {
          // Algo sucedió al configurar la petición
          errorMessage = `Error de la aplicación: ${err.message}`;
        }

        // Muestra el snackbar con el mensaje de error (si no fue manejado asincrónicamente por el FileReader)
        if (!(err.response && err.response.data instanceof Blob)) {
          this.showSnackbar(errorMessage, 'error');
        }
        window.console.error("Error generando certificado:", err.response.data.error);
        this.$root.$notify.show(errorMessage, { color: 'error' });


        //window.console.error("Error generando certificado:", err);

      }finally {
        this.cargando = false;
      }




      // this.dialog2 = true;
      // this.pdfUrl = null; // Resetear URL del PDF
      window.console.log('verCertificado', item);
      // Aquí puedes implementar la lógica para generar o mostrar el certificado
      // Por ejemplo, podrías hacer una llamada a un endpoint que genere el certificado
      // y luego asignar la URL del PDF a this.pdfUrl
      //this.generarCertificado();
    }
  }
};
</script>

<style scoped>
.avatar-border-solid {
  border: 1px solid #1976D2;
  /* 3px de grosor, sólido, color azul (primary de Vuetify) */
}

.avatar-border-dotted {
  border: 4px dotted #E53935;
  /* 4px de grosor, punteado, color rojo */
}

.avatar-border-double {
  border: 5px double white;
  /* 5px de grosor, doble, color blanco */
}
</style>